import { render, staticRenderFns } from "./StatusUserChanging.vue?vue&type=template&id=f036f4b4&scoped=true"
import script from "./StatusUserChanging.vue?vue&type=script&lang=js"
export * from "./StatusUserChanging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f036f4b4",
  null
  
)

export default component.exports